export default __webpack_public_path__ + "static/dioriteLogoTransparent3-d1260b85e1de227766446d378f8d5a52.png";